import { Link } from 'react-router-dom';
import { Heart, Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-muted/50 border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Heart className="w-6 h-6 text-primary fill-primary" />
              <span className="font-serif text-2xl font-semibold text-foreground">
                Mi Boda Perfecta
              </span>
            </Link>
            <p className="text-muted-foreground mb-6 max-w-md">
              Tu marketplace de bodas donde encontrarás todo lo necesario para crear el día más especial de tu vida, sin necesidad de wedding planner.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">Explora</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/vendors" className="text-muted-foreground hover:text-primary transition-colors">
                  Proveedores
                </Link>
              </li>
            </ul>
          </div>

          {/* For Vendors */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">Proveedores</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/backoffice" className="text-muted-foreground hover:text-primary transition-colors">
                  Acceso Proveedores
                </Link>
              </li>
              <li>
                <Link to="/backoffice/register" className="text-muted-foreground hover:text-primary transition-colors">
                  Registrar mi Negocio
                </Link>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Cómo Funciona
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground text-sm space-y-1">
          <p>© 2026 Mi Boda Perfecta. Todos los derechos reservados.</p>
          <p>
            Un producto desarrollado por{' '}
            <a
              href="https://growists.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary font-medium hover:underline"
            >
              Growists
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
